import { useState } from 'react'

export const useForceUpdate = (): (() => void) => {
    const [render, setRender] = useState(true)
    return () => setRender(!render)
}
